import moment, { Moment } from 'moment';

import { DATE_FORMAT } from '../utils/constants';

export class MemberMedication {
  action = '';

  dispense = '';

  duration = '';

  format = '';

  frequency = '';

  name = '';

  refills = '';

  route = '';

  size = '';

  source = '';

  take = '';

  updatedAt?: Moment;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.updatedAt = obj.updatedAt
      ? moment(obj.updatedAt, DATE_FORMAT)
      : undefined;
  }

  get medicationName() {
    return [this.name, this.size, this.format].filter(Boolean).join(' ');
  }

  get directions() {
    return [this.take, this.route, this.frequency].filter(Boolean).join(' ');
  }
}

export default MemberMedication;
